import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import { Card, Col, Container, Row } from "reactstrap";

import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  getAssignCubesFillerToMachinOperators,
  getMachineOperatorDashboard,
  getMachineOperatorStock,
} from "api";
import moment from "moment/moment";
import { withTranslation } from "react-i18next";

class MachineOperatorDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
      stockList: [],
      rejectStockList: [],
      inwardStockList: [],
      dashboardInfo: "",
    };
  }

  async componentDidMount() {
    const dashboard = await getMachineOperatorDashboard();
    if (dashboard && dashboard.data) {
      this.setState({
        dashboardInfo: dashboard.data,
      });
    }
    const data = await getAssignCubesFillerToMachinOperators({
      page: 1,
      limit: 10,
      machineOperatorStatus: "P",
      machineOperatorId: null,
    });
    if (data && data.data) {
      this.setState({
        stockList:
          data.data.cubeBelts.length == 0
            ? [
                {
                  user: {
                    name: 0,
                  },
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  cubeInformations: [],
                  machinUser: {
                    name: 0,
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  process:{
                    name:0
                  },
                  machineOperatorId: 0,
                  cubeId: 0,
                  usedCylinder: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  remarks: "",
                  updatedAt: "",
                  fillerStatus: "P",
                  assignGraderToFillerStock: null,
                },
              ]
            : data.data.cubeBelts,
      });
    }
    const inwardStock = await getMachineOperatorStock({
      page: 1,
      limit: 5,
    });
    if (inwardStock && inwardStock.data) {
      this.setState({
        inwardStockList:
          inwardStock.data.machineOperatorStocks.length == 0
            ? [
                {
                  user: {
                    name: 0,
                  },
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  stockMachineOperatorInWards: [],
                  cubeBelt: {
                    cubeId: 0,
                    processId: 0,
                    machinUser: {
                      name: 0,
                    },
                    user: {
                      name: 0,
                    },
                  },
                  processId: 0,
                  process:{
                    name:0
                  },
                  machineOperatorId: 0,
                  cubeId: 0,
                  usedCylinder: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  remarks: "",
                  updatedAt: "",
                  fillerStatus: "P",
                  assignGraderToFillerStock: null,
                },
              ]
            : inwardStock.data.machineOperatorStocks,
      });
    }
    const rejectStock = await getAssignCubesFillerToMachinOperators({
      page: 1,
      limit: 10,
      machineOperatorStatus: "R",
    });
    if (rejectStock && rejectStock.data) {
      this.setState({
        rejectStockList:
          rejectStock.data.cubeBelts.length == 0
            ? [
                {
                  user: {
                    name: 0,
                  },
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  machineOperatorId: 0,
                  cubeId: 0,
                  usedCylinder: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  remarks: "",
                  updatedAt: "",
                  fillerStatus: "P",
                  assignGraderToFillerStock: null,
                },
              ]
            : rejectStock.data.cubeBelts,
      });
    }
  }

  render() {
    this.columns3 = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "cubeId",
        text: `${this.props.t("Belt Id")}`,
        sort: true,
      },
      {
        dataField: "usedCylinder",
        text: `${this.props.t("Used Cylinder")}`,
        sort: true,
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        formatter:(cell, row) => {
          return row.process.name
        }
      },
      {
        dataField: "totalPieces",
        text: `${this.props.t("Total Pieces")}`,
        formatter: (cell, row) => {
          return row.cubeInformations.length;
        },
        sort: true,
      },
      {
        dataField: "machineOperatorId",
        text: `${this.props.t("Machine Operator")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.machinUser?.name;
        },
      },
      {
        dataField: "remarks",
        text: this.props.t("Filler Notes"),
        sort: true,
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Assigned Date")}`,
        sort: true,
        formatter: cell => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight != 0 && (
            <div className="btn-group">
              <Link
                to={{
                  pathname: "/machine-operator-edit-verify-accept",
                  query: { isEdit: 1, data: row },
                }}
              >
                <button className="py-2 px-2 border-0 rounded">
                  <img src="images/dashboard-images/edit.svg" />
                </button>
              </Link>
            </div>
          ),
      },
    ];
    this.columns1 = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "cubeId",
        text: `${this.props.t("Belt Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt.cubeId;
        },
      },
      {
        dataField: "machineId",
        text: `${this.props.t("Machine Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.machineId;
        },
      },
      {
        dataField: "totalPieces",
        text: `${this.props.t("Total Pieces")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.stockMachineOperatorInWards.length;
        },
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt?.process?.name;
        },
      },
      {
        dataField: "machineOperatorId",
        text: `${this.props.t("Machine Operator")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.user?.name;
        },
      },
      {
        dataField: "fillerName",
        text: `${this.props.t("Filler")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt.user.name;
        },
      },
      {
        dataField: "remarks",
        text: this.props.t("Filler Notes"),
        sort: true,
      },
      {
        dataField: "updatedAt",
        text: `${this.props.t("Assigned Date")}`,
        sort: true,
        formatter: cell => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight != 0 &&
          (row.graderStatus == "A" ? (
            <Link
              to={{
                pathname: "/machine-operator-edit-verify-accept",
                query: { isEdit: 3, data: row },
              }}
            >
              <button className="py-2 px-2 ms-2 border-0 rounded">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          ) : (
            <div className="btn-group">
              <Link
                to={{
                  pathname: "/machine-operator-edit-verify-accept",
                  query: { isEdit: 2, data: row },
                }}
              >
                <button className="py-2 px-2 border-0 rounded">
                  <img src="images/dashboard-images/edit.svg" />
                </button>
              </Link>
              <Link
                to={{
                  pathname: "/machine-operator-edit-verify-accept",
                  query: { isEdit: 3, data: row },
                }}
              >
                <button className="py-2 px-2 ms-2 border-0 rounded">
                  <img src="images/dashboard-images/view.svg" />
                </button>
              </Link>
            </div>
          )),
      },
    ];
    this.columns2 = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "cubeId",
        text: `${this.props.t("Belt Id")}`,
        sort: true,
      },
      {
        dataField: "usedCylinder",
        text: `${this.props.t("Used Cylinder")}`,
        sort: true,
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        formatter:(cell,row) => {
          return row.process?.name 
        }
      },
      {
        dataField: "machineOperatorId",
        text: `${this.props.t("Machine Operator")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.user?.name;
        },
      },
      {
        dataField: "remarks",
        text: this.props.t("Filler Notes"),
        sort: true,
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Assigned Date")}`,
        sort: true,
        formatter: cell => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      // {
      //   dataField: "viewdetail",
      //   text:`${this.props.t('View Details')}`,
      //   formatter: (cell, row) => (
      //     <div className="btn-group">
      //       <Link
      //         to={{
      //           pathname: "/machine-operator-edit-verify-accept",
      //           query: { isEdit: 3, data: row },
      //         }}
      //       >
      //         <button className="py-2 px-2 border-0 rounded">
      //           <img src="images/dashboard-images/edit.svg" />
      //         </button>
      //       </Link>
      //     </div>
      //   ),
      // },
    ];

    document.title = "machine operator flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={this.props.t("Machine operator Dashboard")}
            />

            <div className="row">
              <div className="col-xl-4 col-12">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("To Receive / Pending List")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.pending}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 mt-3 mt-xl-0">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("Received/My Stock")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.received}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 mt-3 mt-xl-0">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("Forward to Boil Man")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.forwardToBoilman}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 mt-3">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("Accepted By Grader")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.acceptedByGrader}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row px-3 pt-4">
              <Card className="mt-4">
                <div className="d-lg-flex d-block text-center text-lg-start py-3 justify-content-between">
                  <div>
                    <h2 className="fw-bold text-black">
                      {this.props.t("Pending Belt Details")}
                    </h2>
                  </div>
                  {/* <div>
                    <label
                      htmlFor="date"
                      className="fs-5 text-black fw-bold pe-3"
                    >
                      {" "}
                      Assign Date:
                    </label>
                    <input type="date" className="fs-5 border-0" />
                  </div> */}
                </div>
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    bordered={false}
                    striped={false}
                    data={this.state.stockList}
                    columns={this.columns3}
                  />
                </div>
              </Card>
              <Card className="mt-4">
                <div className="d-lg-flex d-block text-center text-lg-start py-3 justify-content-between">
                  <div>
                    <h2 className="fw-bold text-black">
                      {this.props.t("Inward Belt List")}
                    </h2>
                  </div>
                </div>
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    bordered={false}
                    striped={false}
                    data={this.state.inwardStockList}
                    columns={this.columns1}
                  />
                </div>
              </Card>
              <Card className="mt-4">
                <div className="d-lg-flex d-block text-center text-lg-start py-3 justify-content-between">
                  <div>
                    <h2 className="fw-bold text-black">
                      {this.props.t("Reject Belt List")}
                    </h2>
                  </div>
                </div>
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    bordered={false}
                    striped={false}
                    data={this.state.rejectStockList}
                    columns={this.columns2}
                  />
                </div>
              </Card>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(MachineOperatorDashboard);
